import React, { useState } from 'react'
import { Button, Dialog } from '@material-ui/core'
import { connect } from 'react-redux'
import { formValueSelector, reduxForm } from 'redux-form'
import { COLORES } from '../../../../config/colores'
import { FORM_PLAN_DE_EMBARQUE } from '../../../../config/forms'
import { TABLA_PLAN_DE_EMBARQUE } from '../../../../config/tables'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import CamposPlanDeEmbarque from './CamposPlanDeEmbarque'
import { EMPLY_PLAN_DE_EMBARQUE_BODEGA } from '../../actions/constantesPlanDeEmbarque'
import { toast } from 'react-toastify'
import { submitPlanDeEmbarqueBodega } from '../../actions/PlanDeEmbarqueActions'
import DialogView from '../../../Dialogos/DialogView'
import BodegasBuque from '../BodegasBuque'
import { Row, Col } from 'react-bootstrap'

function TablaPlanDeEmbarqueBodegasView (props) {
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => { setOpen(false) }

  const handleSubmit = () => {
    const { cereal, peso, bodega, paisDestino } = props

    if (cereal !== '' && cereal !== 'UNDEF') {
      if (bodega !== '') {
        if (paisDestino !== '' && paisDestino !== 'UNDEF') {
          if (peso > 0) {
            props.submitPlanDeEmbarqueBodega()
          } else {
            toast.error('Debe ingresar un peso mayor a 0')
          }
        } else {
          toast.error('Debe ingresar el pais destino de la bodega')
        }
      } else {
        toast.error('Debe seleccionar una bodega')
      }
    } else {
      toast.error('Debe ingresar el cereal')
    }
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='md'
      >
        <DialogView
          cancelCallback={handleClose}
          title='Bodegas buque'
          content={<BodegasBuque buque={props.buque} />}
        />
      </Dialog>
      <hr />
      <div className='cabecera-detalle-bodega'>
        <h6 style={{ borderBottom: '1px solid', borderColor: COLORES.grey.medium }} > Detalle de bodega </h6>
        <Button
          variant='outlined'
          style={{ color: COLORES.blue.primary, fontWeight: 'bold' }}
          onClick={handleOpen}
          size='small'
        >
          Agregar o editar bodegas
        </Button>
      </div>
      <hr />

      <CamposPlanDeEmbarque />

      <Row style={{ textAlign: 'left', marginTop: '8px' }}>
        <Col md={9}>
          <p style={{ marginLeft: '1.5%' }}>(*) Campo requerido obligatorio</p>
        </Col>
        <Col md={3}>
          <Button
            variant='contained'
            style={{ color: COLORES.blue.primary, width: '100%', fontWeight: 'bold' }}
            size='small'
            onClick={handleSubmit}
          >
                Agregar
          </Button>
        </Col>
      </Row>

      <hr />

      <MuiTable id={TABLA_PLAN_DE_EMBARQUE} />
    </>
  )
}

const selector = formValueSelector(FORM_PLAN_DE_EMBARQUE)

const mapStateToProps = (state) => ({
  bodega: selector(state, 'bodega'),
  buque: selector(state, 'buque'),
  cereal: selector(state, 'cereal'),
  peso: selector(state, 'peso'),
  paisDestino: selector(state, 'paisDestino')
})

const mapActionsToProps = {
  submitPlanDeEmbarqueBodega
}

const withRedux = connect(mapStateToProps, mapActionsToProps)

const withReduxForm = reduxForm({
  form: FORM_PLAN_DE_EMBARQUE,
  initialValues: EMPLY_PLAN_DE_EMBARQUE_BODEGA,
  enableReinitialize: true
})

export default withRedux(withReduxForm(TablaPlanDeEmbarqueBodegasView))
